const PARK_AND_FLY_SERVICES = [
  'PARK_AND_FLY_AIRPORT_TRANSFER',
  'PARK_AND_FLY_CAR_SEAT',
  'PARK_AND_FLY_KEY_STORAGE',
  'PARK_AND_FLY_SAFE'
]

export default PARK_AND_FLY_SERVICES
